import Image from 'snippets/image/image'
import Price from 'snippets/price/price'

function ProductBackInStockCard({ product }) {
  const productUrl = product?.url || `/products/${product?.handle}` || ''
  const compareAtPrice = product?.compareAtPrice || product?.compare_at_price

  return (
    product && (
      <div className="flex border-b border-neutral-900">
        <a href={productUrl} aria-label={`View ${product.title} Product`} className="block w-[117px] bg-neutral-100 border-r border-neutral-900 lg:w-[133px]">
          <Image
            key={product.featuredImage?.src}
            url={product.featuredImage?.src}
            alt={product.type ? `${product.title} ${product.type}` : product.title}
            imageClass="size-full"
            className="aspect-4/5 w-full"
          />
        </a>
        <div className="flex flex-col justify-center px-5 flex-1 my-auto py-3">
          <h3>
            <a
              href={productUrl}
              className="block w-fit text-xs font-extrabold uppercase text-neutral-900"
            >
              {product.title}
            </a>
          </h3>
          {product.type && <p className="mt-0.5 text-xs-medium text-neutral-700 lg:text-xs">{product.type}</p>}
          <Price
            price={product.price}
            originalPrice={compareAtPrice}
            classSalePrice="text-xs-medium lg:text-xs font-medium text-neutral-500"
            className="mt-2.5 flex gap-2 text-xs-medium font-medium text-neutral-900 lg:text-xs"
          />
        </div>
      </div>
    )
  )
}

export default ProductBackInStockCard
